var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFolderIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1058",
    "data-name": "Group 1058",
    transform: "translate(-442.615 -161.615)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(442.615 161.615)",
    fill: "#02acf6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-exposure-plus-1",
    "data-name": "Icon material-exposure-plus-1",
    d: "M12.416,10.5H10.277v4.277H6v2.139h4.277v4.277h2.139V16.916h4.277V14.777H12.416Z",
    transform: "translate(440.269 154.769)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFolderIc);
export default __webpack_public_path__ + "static/media/add-folder_ic.791be60d6a051c1dd92a694465705796.svg";
export { ForwardRef as ReactComponent };